module.exports = __webpack_public_path__ + "img/76_21.d79c799f.png";